import { RowInfo } from '../models/row-info';
import { RowId } from './row-id-enum';

export const eRows = (): RowInfo[][] => [e1Rows(), e2Rows(), e3Rows()];

const e1Rows = (): RowInfo[] => [
  {
    description:
      'Analisi delle finalità del finanziamento e compatibilità con criteri di erogazione ESG',
    id: RowId.analisiDelleFinalitaDelFinanziamentoECompatibilitaConCriteriDiErogazioneEsg,
    options: [
      { view: 'Finanziamento con finalità ESG', value: 2 },
      { view: 'Finanziamento con altre finalità', value: 0 },
    ],
    kriWeight: 100,
  },
];

const e2Rows = (): RowInfo[] => [
  {
    description: 'Verifica della DD su temi ESG',
    id: RowId.verificaDellaDdSuTemiEsg,
    options: [
      { view: 'Esito positivo', value: 2 },
      { view: 'Esito positivo con alcune criticità', value: 1 },
      { view: 'Esito negativo', value: 0 },
    ],
    kriWeight: 100,
  },
];

const e3Rows = (): RowInfo[] => [
  {
    description: 'Rating ESG (se disponibile) fornito da data provider',
    id: RowId.ratingEsgSeDisponibileFornitoDaDataProvider,
    options: [
      { view: 'Rating fascia alta', value: 2 },
      { view: 'Rating fascia media', value: 1 },
      { view: 'Rating fascia bassa o non presente', value: 0 },
    ],
    kriWeight: 100,
  },
];
